import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Heading, LinkButton, Stack, Text } from '@eluve/components';

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Not found | Eluve</title>
      </Helmet>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 text-center sm:py-32 lg:px-8">
        <Stack direction="vertical" align="center" gap={6}>
          <Text size="md" weight="semibold">
            404
          </Text>
          <Heading size="3xl" weight="bold" level={1}>
            Page not found
          </Heading>
          <Text size="md" color="secondary">
            Sorry, we couldn’t find the page you’re looking for.
          </Text>
          <LinkButton to="/">Go back home</LinkButton>
        </Stack>
      </main>
    </>
  );
};
